module.exports = {"pathContext":{"name":"Bill","kind":"UNION","type":"OBJECT","fields":null,"description":"A bill is a pending order, posted invoice, or published estimate","enumValues":null,"possibleTypes":[{"kind":"OBJECT","name":"Estimate","ofType":null},{"kind":"OBJECT","name":"Order","ofType":null}]}}


//////////////////
// WEBPACK FOOTER
// ./~/json-loader!./.cache/json/union-bill.json
// module id = 2139
// module chunks = 10483611427234